import { render, staticRenderFns } from "./WallOfLove.vue?vue&type=template&id=4260d767&"
import script from "./WallOfLove.vue?vue&type=script&lang=js&"
export * from "./WallOfLove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports